import React, { useRef } from 'react';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import { Paragraph } from '@uncinc/react-drupal-core';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import HeroSlider from '../../HeroSlider';

import './style.scss';

// @TODO: Rewrite this and HeroSlider components to not use Drupal context.
const HeroRegenboog = ({ entity }) => {
  const sliderRef = useRef(null);
  const { t } = useTranslation();

  return (
    <Container className="NodeLandingPageFull__hero">
      {/* For A11y render h1 with info about the website */}
      <h1 className="sr-only">{t('general.welcome_message')}</h1>
      {/*
        The order makes sure the title is semantically at the top of the dom
        while being pushed down visually.
      */}
      <div className="row order-3">
        <div className="col-12">
          <h1 className="NodeLandingPageFull__title">{entity.getIn(['field_title', 0, 'value'])}</h1>
        </div>
      </div>

      <div className="row HeroSlider__row order-1">
        <div className="col-12 col-md-10 offset-md-2">
          {/* init Hero Slider */}
          <HeroSlider
            entity={entity}
            sliderRef={sliderRef}
          />
        </div>
      </div>

      <div className="NodeLandingPageFull__cta_actions order-2">
        <div className="row">
          <div className="col-12 NodeLandingPageFull__cta_actions__wrapper">
            {/* Start of carousel items CTA */}
            {entity.get('field_carousel_paragraph_items') ? (
              <div className="node--page--paragraphs-wrapper">
                {entity.get('field_carousel_paragraph_items', Immutable.List()).map((paragraph, index) => {
                  const id = paragraph.get('target_id');
                  return (
                    <Paragraph
                      key={`field_carousel_paragraph:${id}`}
                      id={id}
                      entity={paragraph.get('entity')}
                      index={index}
                      sliderRef={sliderRef}
                    />
                  );
                })}
              </div>
            ) : null}
            {/* End of carousel items CTA */}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default HeroRegenboog;
